export function validateIsEmail(email) {
  const pattern = new RegExp(
    '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  );
  return pattern.test(email);
}

export function validateEmailAddress(rule, value) {
  if (!validateIsEmail(value)) {
    return Promise.reject('Email is not valid.');
  }
  return Promise.resolve();
}

export function validateStrongPassword(rule, value) {
  if (!validateIsStrongPassword(value)) {
    return Promise.reject(
      'Password must contain number and alphabetical characters and the length is between 6 and 20.',
    );
  }
  return Promise.resolve();
}

/**
 * Password must contain at least one numeric and one alphabetical character,
 * and be between 6 and 20 characters long.
 */
function validateIsStrongPassword(password) {
  const pattern = new RegExp('^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{6,20}$');
  return pattern.test(password);
}

export const cognitoPasswordGuidance =
  'Use at least eight characters, uppercase and lowercase letters, a number and a symbol. No spaces.';

export function validateCognitoPassword(rule, password) {
  if (
    typeof password !== 'string' ||
    password.length > 256 ||
    Array.from(password).length < 8 ||
    !/^[\p{L}\p{M}\p{S}\p{N}\p{P}]+$/u.test(password) ||
    !/[A-Z]/.test(password) ||
    !/[a-z]/.test(password) ||
    !/[0-9]/.test(password) ||
    !/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(password)
  )
    return Promise.reject(cognitoPasswordGuidance);
  return Promise.resolve();
}
